import ImagePreview from "@/components/Common/ImagePreview/ImagePreview.vue";
import { createError } from "@/helpers/newsHelper";
import { updateLockingFile } from "../../../helpers/fileHelper";
import { aiAttributionItems } from "@/helpers/commonHelper";

export default {
  name: "POIImagePreview",
  extends: ImagePreview,
  props: ["showFitCoverCheckbox"],
  data() {
    return {
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      mainGray: "#7a7a7a",
      aiAttributionItems
    };
  },
  computed: {
    showLockCheckbox() {
      return this.$store.state.selectedPrincipal?.showLockCheckbox;
    },
    fileAiAttribution: {
      get() {
        return this.fileToEdit?.ai_attribution ?? "";
      },
      set(value) {
        this.$set(this.fileToEdit, "ai_attribution", value ?? "");
      }
    },
    fileFitCover: {
      get() {
        return !!this.fileToEdit?.fit_cover;
      },
      set(value) {
        this.$set(this.fileToEdit, "fit_cover", !!value);
      }
    },
    shouldShowFitCoverCheckbox() {
      return this.showFitCoverCheckbox !== false;
    },
    imageUrl() {
      return this.getImageUrl(this.fileToEdit);
    }
  },
  methods: {
    createError,
    getImageUrl(image = this.fileToEdit) {
      const fitCover = image?.fit_cover;
      const croppedUrl =
        image?.[this.imageSizeField]?.[this.selectedRatio]?.url;

      if (fitCover && croppedUrl) {
        return croppedUrl;
      }

      return image?.url ?? image?.originalUrl ?? croppedUrl ?? "";
    },
    checkFileSizes(file) {
      if (!this.showImageAspectRatioButtons) {
        return !file?.imageSizes?.["16:9"];
      }
      if (!file?.imageSizes) return true;
      if (!file.imageSizes["16:9"]) return true;
      if (!file.imageSizes["3:1"]) return true;
      if (!file.imageSizes["1:1"]) return true;
    },
    imgFilename(file) {
      return file?.url?.split("/").reverse()[0];
    },
    async updateFile(file) {
      await updateLockingFile(file.id, file.url, file.locked);
    },
    isImageFromExternalSource(image) {
      const internalSources = [
        "download.eberl-online",
        "download-test.eberl-online",
        "download-test.eo-heimat",
        "download.eo-heimat"
      ];
      return !internalSources.some(source =>
        this.getImageUrl(image).includes(source)
      );
    }
  }
};
